// Pied de page SNK : colonnes de liens en accordéon sur mobile, toujours ouvertes dès la tablette (750 px).
if (!customElements.get('snk-footer-columns')) {
  customElements.define(
    'snk-footer-columns',
    class SnkFooterColumns extends HTMLElement {
      connectedCallback() {
        this.desktop = window.matchMedia('(min-width: 750px)');
        this.columns = this.querySelectorAll('details');
        this.sync = () => this.columns.forEach((column) => (column.open = this.desktop.matches));
        this.desktop.addEventListener('change', this.sync);
        this.sync();

        // Dès la tablette, les titres ne replient rien (stopPropagation : snk-details.js n'anime pas non plus)
        this.querySelectorAll('summary').forEach((summary) =>
          summary.addEventListener('click', (event) => {
            if (this.desktop.matches) {
              event.preventDefault();
              event.stopPropagation();
            }
          })
        );
      }

      disconnectedCallback() {
        this.desktop.removeEventListener('change', this.sync);
      }
    }
  );
}
